// extracted by mini-css-extract-plugin
module.exports = {"hero":"bh_fm"};